/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function FeatureFlags({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#FeatureFlags_svg__clip0_2920_2994)"><path fill="currentColor" d="M13.997.4a.85.85 0 0 1 .809 1.11l-.043.108-1.17 2.436 1.849 2.431.07.108a.85.85 0 0 1-.747 1.257h-1.976a.6.6 0 0 1 0-1.2h1.27l-1.55-2.04a.85.85 0 0 1-.09-.882L13.441 1.6H1.69l.825 5.05h1.183l.12.012a.6.6 0 0 1 0 1.176l-.12.012H2.71l1.15 7.053a.6.6 0 0 1-1.184.194L.404 1.147A.597.597 0 0 1 .77.441L.784.437a1 1 0 0 1 .1-.027L.89.408C.902.406.914.408.926.406Q.954.401.983.4zM8.265 2.35a.6.6 0 0 1 1.036.412v3.502h1.393a.6.6 0 0 1 .497.935l-3.008 4.453a.6.6 0 0 1-1.097-.336V7.854H5.694a.6.6 0 0 1-.6-.6l.001-.02a.6.6 0 0 1 .102-.355l3.007-4.453zm.02 7.006 1.28-1.893H8.72a.6.6 0 0 1-.435-.19zM6.797 6.654h.89c.162 0 .308.065.416.17V4.72z" /></g></svg>;
}
;